<p *ngIf="error" role="alert" class="text-danger">{{ error }}</p>
<tt-page *ngIf="page">
    <tt-card *ngIf="page.show_button_new_report === '1'" class="col-xs-12 sp-0">
        <tt-button [ttText]="page.text_button_new_report" ttIcon="fas fa-plus" ttIconPullRight (ttClick)="newReport()"></tt-button>
    </tt-card>
    <tt-list [ttData]="reports" ttBadge="badgeinfo" ttBackStyle [ttGoto]="false" (ttClick)="openItem($event)"></tt-list>
</tt-page>
